// ————————————————————————————————————————————— DOC. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import { gsap } from "gsap";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const msgs = {
  start_out: "%cpage trans. → open overlay → trans. out",
  start_in: "%cpage trans. → open overlay → trans. in",
  skip_out: "%cpage trans. → open overlay → trans. out → skip (no anim. necessary)",
  skip_in: "%cpage trans. → open overlay → trans. in → skip (no anim. necessary)",
  done_in: "%cpage trans. → open overlay → trans. in → complete",
  done_out: "%cpage trans. → open overlay → trans. out → complete",
};

const logStyles = {
  def: "color: MediumPurple; font-weight: bold;",
  success: "color: MediumAquamarine; font-weight: bold;",
  error: "color: red; font-weight: bold;",
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default {
  /////////////////////////// Route selection ////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  from: /^\/(home)?$/, // ← '/'
  to: "/test-overlay-page",

  ///////////////////////////////// Out //////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  out: async () => {
    console.log(msgs.start_out, logStyles.def);

    // Slide up + fade out...
    await gsap.to("#overlayPageWrapper", { opacity: 0, y: -50, duration: 0.333 });
  },

  ///////////////////////////////// In ///////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  in: async () => {
    console.log(msgs.start_in, logStyles.def);

    // Slide down + fade in...
    await gsap.fromTo("#overlayPageWrapper", { opacity: 0, y: 50 }, { opacity: 1, y: 0, duration: 0.333 });
  },
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
